import { gql } from '@apollo/client';

export const PAYOUT = gql`
mutation payoutToPublishers($inputs: [PublisherPaymentInput]) {
  payoutToPublishers(inputs: $inputs)
}
`;
